import PhotographersApi from './PhotographersApi';
import * as types from './PhotographerActionTypes';
import IPhotographerInput from './IPhotographerInput';
import IPhotographer from './IPhotographer';

function addPhotographerSuccess(userResult: IPhotographerInput) {
    return { type: types.ADD_PHOTOGRAPHER_SUCCESS, userResult };
}

export function addPhotographer(user: IPhotographerInput) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        PhotographersApi.addPhotographer(user).then((result: any) => {
            dispatch(addPhotographerSuccess(result));
        });
}

function newPhotographerSuccess(viewModel: any) {
    return { type: types.LOAD_NEW_PHOTOGRAPHER_SUCCESS, viewModel };
}

export function newPhotographer() {
    return (dispatch: any) =>
        PhotographersApi.newPhotographer().then((result: any) => {
            dispatch(newPhotographerSuccess(result));
        });
}

function loadPhotographersSuccess(userResult: IPhotographer[]) {
    return { type: types.LOAD_PHOTOGRAPHERS_SUCCESS, userResult };
}

export function listPhotographers() {
    return (dispatch: any) =>
        PhotographersApi.listPhotographers().then((result: IPhotographer[]) => {
            dispatch(loadPhotographersSuccess(result));
        });
}

function getEditPhotographerSuccess(viewModel: IPhotographerInput) {
    return { type: types.GET_EDIT_PHOTOGRAPHER_SUCCESS, viewModel };
}

export function getEditPhotographer(id: number) {
    return (dispatch: any) =>
        PhotographersApi.getEditPhotographer(id).then((result: IPhotographerInput) => {
            dispatch(getEditPhotographerSuccess(result));
        });
}

function updatePhotographerSuccess(userResult: IPhotographer) {
    return { type: types.UPDATE_PHOTOGRAPHER_SUCCESS, userResult };
}

export function updatePhotographer(id: number, user: IPhotographerInput) {
    return (dispatch: any) =>
        PhotographersApi.updatePhotographer(id, user).then((result: IPhotographer) => {
            dispatch(updatePhotographerSuccess(result));
        });
}

function getPhotographerCalendarSuccess(result: any) {
    return { type: types.GET_PHOTOGRAPHER_CALENDAR_SUCCESS, result };
}

export function getPhotographerCalendar(id: number, from: any, to: any) {
    return function (dispatch: (result: any) => void) {
        return PhotographersApi.getPhotographerCalendar(id, from, to).then((result: any) => {
            dispatch(getPhotographerCalendarSuccess(result));
        });
    };
}

function createCubiCasaConnectionSuccess(result: any) {
    return { type: types.CREATE_CUBICASA_CONNECTION_SUCCESS, result };
}

export function createCubiCasaConnection(id: number) {
    return function (dispatch: (result: any) => void) {
        return PhotographersApi.createCubiCasaConnection(id).then((result: any) => {
            dispatch(createCubiCasaConnectionSuccess(result));
        });
    };
}

function updatePhotographerWorkingHoursSuccess(result: any) {
    return {
        type: types.UPDATE_PHOTOGRAPHER_WORKING_HOURS_SUCCESS,
        result
    };
}

export function updatePhotographerWorkingHours(
    userId: number,
    se360WorkingHours: any[],
    scandphotosWorkingHours: any[]
) {
    return function (dispatch: (result: any) => void) {
        return PhotographersApi.updatePhotographerWorkingHours(
            userId,
            se360WorkingHours,
            scandphotosWorkingHours
        ).then((result) => {
            se360WorkingHours = se360WorkingHours.map((x) => {
                x.userId = userId;
                return x;
            });

            scandphotosWorkingHours = scandphotosWorkingHours.map((x) => {
                x.userId = userId;
                return x;
            });

            dispatch(
                updatePhotographerWorkingHoursSuccess({
                    se360WorkingHours: se360WorkingHours,
                    scandphotosWorkingHours: scandphotosWorkingHours
                })
            );
        });
    };
}

